var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80529 0C2.60817 0 0 2.60817 0 5.80529V14.2007C0 17.3918 2.60817 20 5.80529 20H14.2007C17.3918 20 20 17.3918 20 14.1947V5.80529C20 2.60817 17.3918 0 14.1947 0H5.80529ZM5.80529 1.53846H14.1947C16.5625 1.53846 18.4615 3.4375 18.4615 5.80529V14.1947C18.4615 16.5625 16.5625 18.4615 14.2007 18.4615H5.80529C3.4375 18.4615 1.53846 16.5625 1.53846 14.2007V5.80529C1.53846 3.4375 3.4375 1.53846 5.80529 1.53846ZM16.1538 3.07692C15.7272 3.07692 15.3846 3.41947 15.3846 3.84615C15.3846 4.27284 15.7272 4.61538 16.1538 4.61538C16.5805 4.61538 16.9231 4.27284 16.9231 3.84615C16.9231 3.41947 16.5805 3.07692 16.1538 3.07692ZM10 4.61538C7.03726 4.61538 4.61538 7.03726 4.61538 10C4.61538 12.9627 7.03726 15.3846 10 15.3846C12.9627 15.3846 15.3846 12.9627 15.3846 10C15.3846 7.03726 12.9627 4.61538 10 4.61538ZM10 6.15385C12.1334 6.15385 13.8462 7.86659 13.8462 10C13.8462 12.1334 12.1334 13.8462 10 13.8462C7.86659 13.8462 6.15385 12.1334 6.15385 10C6.15385 7.86659 7.86659 6.15385 10 6.15385Z",
    fill: "#EAE7E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d2b66c2cdff2051424934c715c944f9f.svg";
export { ForwardRef as ReactComponent };